import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { _isId } from 'app/services/auth.service';
import { CompanyService } from 'app/services/models/company.service';
import { KindService } from 'app/services/models/kind.service';
import { VaultService } from 'app/services/models/vault.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-vault-movement',
  templateUrl: './create-vault-movement.component.html',
  styleUrls: ['./create-vault-movement.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateVaultMovementComponent implements OnInit {
  @Input() data: { vaultId: number; number: number; vaultType?: boolean, manuelBalanceMovement?: Boolean; isExit?: boolean };
  vaultForm: FormGroup;
  kinds: any[] = [];
  vaults: any[] = [];
  companies: any[] = [];

  date = new Date();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y H:i',
    altFormat: 'd.m.Y H:i',
    locale: Turkish,
    defaultDate: this.date
  };

  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private kindService: KindService,
    private vaultService: VaultService,
    private companyService: CompanyService,
    private toastrService: ToastrService
  ) {
    this.vaultForm = this.fb.group({
      balance: ['', Validators.required],
      description: [''],
      kind: [null, Validators.required],
      vault: [null],  // Başlangıçta zorunlu değil
      company: [null], // Başlangıçta zorunlu değil
      vaultDate: [null]
    });
  }

  async ngOnInit() {
    console.log(this.data)
    await this.getAllKinds();
    await this.getAllVaults();
    await this.getAllCompanies();
    if (this.data.number === 1) {
      this.vaultForm.get('company').setValidators(Validators.required);
      this.vaultForm.get('vault').clearValidators();
    } else if (this.data.number === 2 && this.data.manuelBalanceMovement == true) {
      this.vaultForm.get('vault').setValidators(Validators.required);
      this.vaultForm.get('company').clearValidators();
    }

    // Formu yeniden değerlendirin
    this.vaultForm.get('company').updateValueAndValidity();
    this.vaultForm.get('vault').updateValueAndValidity();
  }

  async save() {
    if (this.vaultForm.invalid) {
      // Form geçerli değilse, hataları göster
      this.vaultForm.markAllAsTouched();
      return;
    }
    let selectedDate = null;

    if (this.vaultForm.value.vaultDate && this.vaultForm.value.vaultDate.length > 0) {
      selectedDate = new Date(this.vaultForm.value.vaultDate[0]);
    } else {
      selectedDate = new Date(); // fallback: bugünün tarihi
    }
    if (this.data.number == 1) {
      const data = await this.vaultService.createCompanyVaultMovement(
        this.data.vaultId,
        this.vaultForm.value.balance,
        this.vaultForm.value.kind.id,
        _isId,
        this.vaultForm.value.company.id,
        this.vaultForm.value.description
      );
      if (data.status == true) {
        this.vaultService.sendEvent(true);
        this.toastrService.success(data.message);
      } else {
        this.toastrService.error(data.message);
      }
    }
    if (this.data.number == 2) {
      if (this.data.manuelBalanceMovement == false) {
        console.log('Form Data vault:', this.vaultForm.value);
        if (this.data.isExit == true) {
          const data = await this.vaultService.createVaultVaultMovement(
            this.data.vaultId,
            this.vaultForm.value.balance,
            this.vaultForm.value.kind.id,
            _isId,
            6,
            this.vaultForm.value.description, selectedDate);

          if (data.status == true) {
            this.vaultService.sendEvent(true);
            this.toastrService.success(data.message);
          } else {
            this.toastrService.error(data.message);
          }
        } else {

          const data = await this.vaultService.createVaultVaultMovement(
            6,
            this.vaultForm.value.balance,
            this.vaultForm.value.kind.id,
            _isId,
            this.data.vaultId,
            this.vaultForm.value.description, selectedDate);

          if (data.status == true) {
            this.vaultService.sendEvent(true);
            this.toastrService.success(data.message);
          } else {
            this.toastrService.error(data.message);
          }
        }
      }
      else {
        if (this.data.vaultType == true) {
          const data = await this.vaultService.createVaultVaultMovement(
            this.data.vaultId,
            this.vaultForm.value.balance,
            this.vaultForm.value.kind.id,
            _isId,
            this.vaultForm.value.vault.id,
            this.vaultForm.value.description, selectedDate);

          if (data.status == true) {
            this.vaultService.sendEvent(true);
            this.toastrService.success(data.message);
          } else {
            this.toastrService.error(data.message);
          }
        } else {
          const data = await this.vaultService.createVaultVaultMovement(
            this.vaultForm.value.vault.id,
            this.vaultForm.value.balance,
            this.vaultForm.value.kind.id,
            _isId,
            this.data.vaultId,
            this.vaultForm.value.description, selectedDate);
          if (data.status == true) {
            this.vaultService.sendEvent(true);
            this.toastrService.success(data.message);
          } else {
            this.toastrService.error(data.message);
          }
        }
      }

    }
    this.activeModal.close(true);
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 50, 8);
    console.log(data);

    if (this.data.number == 2) {
      this.kinds = data.types.filter(p => p.typeName == "Transfer");
      this.vaultForm.patchValue({
        kind: this.kinds[0]
      })
    }
    if (this.data.number == 1) {
      this.kinds = data.types.filter(p => p.typeName != "Transfer");
      this.vaultForm.patchValue({
        kind: this.kinds[0]
      })
    }
  }

  async getAllVaults() {
    const data = await this.vaultService.getAllVault(0, 50, '');
    console.log(data);
    this.vaults = data.vaults.filter(vault => vault.id !== this.data.vaultId);
  }

  async getAllCompanies() {
    const data = await this.companyService.getAllCompany('', 0, 100);
    console.log(data);
    this.companies = data.companies;
  }

  closeModal() {
    this.activeModal.close(false);
  }
}
